module.exports = __webpack_public_path__ + "static/media/24.3b452f5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/24.jpg
// module id = 483
// module chunks = 0